import { Breakpoint } from '@mui/material/styles';

import { AllowedPlanChipPlans, FeatureMaturityLevel } from './localstack';

export interface Layout {
  /** Attribute set in the DOM to base element of the current page */
  pageName?: string;
  /** Any components to be rendered within the layout e.g. header and page content */
  children?: React.ReactNode;
  /** The name displayed in the layout page */
  title?: JSX.Element | string;
  /** The name displayed in the browser tab */
  documentTitle?: string;
  /** The navbar component that page expects */
  navigation?: React.ReactNode;
  /** Whether the navbar component should be hidden */
  hideNavigation?: boolean;
}

export type BaseHeaderProps = {
  /** Breadcrumb items displayed on the left side of the header */
  breadcrumbs?: {
    /** Text shown for the breadcrumb link */
    label: string;
    /** Optional URL for navigation; if omitted, item is rendered as plain text */
    href?: string;
  }[];

  /** Maturity of the feature the page belongs to; rendered as a chip next to the page title */
  maturityLevel?: FeatureMaturityLevel;

  /** Optional menu rendered inside a "kebab" (three-dot) menu */
  dropdownActions?: React.ReactNode;

  /** Optional navigation links (e.g., tab-style buttons) displayed next to the kebab menu */
  links?: {
    /** Text shown for the link */
    label: string;
    /** Destination URL */
    href: string;
    /** Whether to render this link; defaults to true */
    display?: boolean;
  }[];

  /** Right-aligned action area (e.g., a single button or a button group) */
  actions?: React.ReactElement | React.ReactElement[];
};

export type DeprecatedBaseHeaderProps = Pick<Layout, 'title' | 'children'> & {
  planFamily?: AllowedPlanChipPlans;
  /** Leading actions shown on the left */
  actions?: React.ReactNode;
  /** Trailing actions shown on the right */
  trailingActions?: React.ReactNode;
  maxWidth?: Breakpoint;
  fullScreen?: boolean;
  flushContent?: boolean;
  tabs?: React.ReactNode;
};

export type ComplexLayoutProps = Layout & DeprecatedBaseHeaderProps;

export type EmulatorLayoutProps = ComplexLayoutProps & {
  /** Endpoint of the current instance */
  endpoint?: string;
};
